import { useLocation } from "react-router-dom"
import { FaEdit, FaPlus } from "react-icons/fa";
import BasicDataTable from "../../../../../Component/BasicComponents/BasicDataTable";
import { useBeatOutletList, useOutletDCRSummary, useOutletOrgNoteList, useOutletRcpaSummary, useOutletSgpiOutSummary } from "../../hooks/useCustomer";
import { CSSProperties, memo, useCallback, useState } from "react";
import RouteModal from "../../../../../Component/BasicComponents/Modal/RouteModal";
import InternalNoteModal from "../../Modal/InternalNoteModal";
import BeatOutletModal from "../../Modal/BeatOutletModal";

interface TableButtonProps {
  onClick: () => void;
  title?: string;
  style?: CSSProperties;
}

const TableButton: React.FC<TableButtonProps> = memo(
  ({ onClick, title = "Add Heads", style }) => {
    const defaultStyle: CSSProperties = {
      display: "flex",
      borderRadius: "20px",
      padding: "2px",
      width: "110px",
      height: "40px",
      justifyContent: "center",
      textAlign: "center",
      alignItems: "center",
    };

    return (
      <div>
        <button
          onClick={onClick}
          className="btn btn-info"
          style={{ ...defaultStyle, ...style }} // External styles override default
        >
          <FaPlus /> <span style={{ marginLeft: "5px" }}>{title}</span>
        </button>
      </div>
    );
  }
);

const TableColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Beat Name",
    selector: (row: { BeatName: string }) => row.BeatName||"-",
  },
  {
    name: "Status",
    selector: (row: { Status: string }) => row.Status||'-',
  },
    {
    name: "Active Date",
    selector: (row: { ActiveDate: string }) => row.ActiveDate||'-',
  },
    {
    name: "Inactive Date",
    selector: (row: { InactiveDate: string }) => row.InactiveDate||'-',
  },
    {
    name: "Report End Date",
    selector: (row: { ReportEndDate: string }) => row.ReportEndDate||'-',
  },
{
      name: "Actions",
    //   width: "208px",
      cell: (row: any) => (
        <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-primary"
                  onClick={() => handleEdit(row)}
                  style={{ borderRadius: "20px", padding: "2px", width: "80px" }}
                >
                  <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
                </button>
              </div>
      )
    }
];

const BeatOutlet=({OutletOrgId}:any)=>{
  const [mode, setmode] = useState<"add" | "edit">("add");
    const [isModal, setIsModal] = useState(false);
      const [selectedRow, setSelectedRow] = useState();
    
  

    console.log('sgpiOut mai',OutletOrgId)
     const [pageState, setPageState] = useState({
     page: 1,
   });
   const [limitState, setLimitState] = useState({
     limit: 10,
   });
   const [search,setSearch]=useState({
     searchValue:null
   })


     const oncloseModal = () => {
    setIsModal(false);
  };
  
    const toggle = () => {
    setIsModal(!isModal);
  };

    const handleEdit = (row: any) => {
    setIsModal(true);
    setmode("edit");
    setSelectedRow(row);
  };

    const handleAddNote = useCallback(() => {
      setIsModal(true);
      setmode("add");
    }, []);

       const {data:BeatList}=useBeatOutletList({
         enabled:!!OutletOrgId,
         id:OutletOrgId,
        params:{
            page:pageState.page,
            limit:limitState.limit,
            search:search.searchValue
        }
       })

    console.log('internal note data',BeatList?.data)





const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
 
      };
  });
      setLimitState((prevState: any) => {
        return {
          ...prevState,
          limit: limit,
        };
      });
    
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  }

   const handleSearch = (searchValue: any) => {
    setSearch((prevState: any) => {
      return {
        ...prevState,
        searchValue,
      };
    });
  }


return(
    <div>
<BasicDataTable
paginationTotalRows={BeatList?.data?.Pagination?.TotalBeatOutlet}
columns={TableColumns(handleEdit)}
data={BeatList?.data?.BeatOutlet||[]}
Title="Beat Outlet"
onChangePage={(pageNo: number) => {
             handlePagination(pageNo);
           }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
           handleonChangeRowsPerPage(newPerPage, page);
         }}
            handleSearch={(val: any) => {
          handleSearch(val);
        }}
        search={false}
       headerContent={
          <TableButton
            onClick={handleAddNote}
            title="Add Beat Outlet"
            style={{
              width: "fit-content",
              padding: "5px 5px",
              height: "30px",
              backgroundColor: "#2e8dd3",
            }}
          />
        }
/>
   <RouteModal
        size="md"
        toggle={toggle}
        isOpen={isModal}
        title={mode == "add" ? "Add Beat Outlet" : "Edit Beat Outlet"}
        content={
          <BeatOutletModal
            mode={mode}
            modalClose={oncloseModal}
            initialData={selectedRow}
            OutletOrgId={OutletOrgId}
          />
        }
      />
    </div>
)
}
export default BeatOutlet